// src/components/BannerSlider.jsx
import { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";
import { ThemeContext } from "../context/ThemeContext";
import { useThemeColors } from "../context/ThemeColorContext";

const BannerSlider = () => {
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);

  const { lang } = useLanguage();
  const { darkMode } = useContext(ThemeContext);
  const {
    darkPrimary,
    darkSecondary,
    darkAccent,
    lightPrimary,
    lightText,
    darkText,
  } = useThemeColors();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/banners/`)
      .then((res) => setBanners(res.data))
      .catch((err) => console.error(err));
  }, []);

  // کنترل اسکرول برای تغییر اسلاید
  useEffect(() => {
    const handleScroll = (e) => {
      if (e.deltaY < 0) {
        setCurrentIndex((prev) =>
          prev > 0 ? prev - 1 : banners.length - 1
        );
      } else if (e.deltaY > 0) {
        setCurrentIndex((prev) =>
          prev < banners.length - 1 ? prev + 1 : 0
        );
      }
    };
    const slider = sliderRef.current;
    if (slider) slider.addEventListener("wheel", handleScroll);
    return () => slider?.removeEventListener("wheel", handleScroll);
  }, [banners.length]);

  if (banners.length === 0) return null;

  return (
    <div
      ref={sliderRef}
      className="relative w-full h-[400px] overflow-hidden"
      style={{ backgroundColor: darkMode ? darkPrimary : "#f3f4f6" }}
    >
      <div
        className="transition-transform duration-700 ease-in-out h-full"
        style={{ transform: `translateY(-${currentIndex * 100}%)` }}
      >
        {banners.map((banner) => (
          <div
            key={banner.id}
            className="w-full h-[400px] bg-cover bg-center flex items-end justify-center p-6 transition-all duration-700"
            style={{ backgroundImage: `url(${banner.image})` }}
          >
            {banner.show_text && (
              <div
                className="max-w-md backdrop-blur-sm rounded-xl p-5 shadow-lg transition-all"
                style={{
                  backgroundColor: darkMode
                    ? `${darkSecondary}cc`
                    : "#ffffffcc",
                  color: darkMode ? darkText : lightText,
                  marginLeft: lang === "en" ? "0" : "auto",
                  marginRight: lang === "fa" ? "0" : "auto",
                }}
              >
                <h2 className="text-lg md:text-xl font-semibold mb-2">
                  {lang === "fa" ? banner.title_fa : banner.title_en}
                </h2>
                <p className="text-sm md:text-base mb-4">
                  {lang === "fa"
                    ? banner.description_fa
                    : banner.description_en}
                </p>
                {banner.button_text && banner.button_url && (
                  <a
                    href={banner.button_url}
                    className="inline-block text-sm font-medium px-4 py-2 rounded transition"
                    style={{
                      backgroundColor: darkMode ? lightPrimary : darkAccent,
                      color: darkMode ? darkAccent : "#fff",
                    }}
                  >
                    {lang === "fa"
                      ? banner.button_text_fa
                      : banner.button_text_en}
                  </a>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full transition ${
              index === currentIndex
                ? "bg-white border border-gray-300"
                : "bg-gray-400"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default BannerSlider;
